var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-config" },
    [
      [
        _c(
          "div",
          { staticClass: "component-wrap" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("基本组件")]),
            _vm._v(" "),
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "list-wrap",
                  attrs: {
                    tag: "ul",
                    list: _vm.baseComponents,
                    clone: function(config) {
                      return _vm.makeFormNodeConfig()
                    }
                  },
                  on: { end: _vm.endDraggable }
                },
                "draggable",
                {
                  group: { name: "base_components", pull: "clone", put: false },
                  sort: false,
                  ghostClass: "ghost"
                },
                false
              ),
              _vm._l(_vm.baseComponents, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: _vm.formExhibitsManager(item).getType(),
                    attrs: {
                      "data-type": _vm.formExhibitsManager(item).getType()
                    },
                    on: {
                      click: function($event) {
                        return _vm.clickAddCompenent(item)
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [
                        "iconfont",
                        _vm.formExhibitsManager(item).getIcon()
                      ]
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formExhibitsManager(item).getName()))
                    ])
                  ]
                )
              }),
              0
            )
          ],
          1
        )
      ],
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "component-wrap" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("高级组件")]),
            _vm._v(" "),
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "list-wrap",
                  attrs: {
                    tag: "ul",
                    list: _vm.advancedComponents,
                    clone: function(config) {
                      return _vm.makeFormNodeConfig()
                    }
                  },
                  on: { end: _vm.endDraggable }
                },
                "draggable",
                {
                  group: {
                    name: "advanced_compoonents",
                    pull: "clone",
                    put: false
                  },
                  sort: false,
                  ghostClass: "ghost"
                },
                false
              ),
              _vm._l(_vm.advancedComponents, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: _vm.formExhibitsManager(item).getType(),
                    attrs: {
                      "data-type": _vm.formExhibitsManager(item).getType()
                    },
                    on: {
                      click: function($event) {
                        return _vm.clickAddCompenent(item)
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [
                        "iconfont",
                        _vm.formExhibitsManager(item).getIcon()
                      ]
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formExhibitsManager(item).getName()))
                    ])
                  ]
                )
              }),
              0
            )
          ],
          1
        )
      ],
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "component-wrap" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("布局组件")]),
            _vm._v(" "),
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "list-wrap",
                  attrs: {
                    tag: "ul",
                    list: _vm.layoutComponents,
                    clone: function(config) {
                      return _vm.makeFormNodeConfig()
                    }
                  },
                  on: { end: _vm.endDraggable }
                },
                "draggable",
                {
                  group: {
                    name: "layout_components",
                    pull: "clone",
                    put: false
                  },
                  sort: false,
                  ghostClass: "ghost"
                },
                false
              ),
              _vm._l(_vm.layoutComponents, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: _vm.formExhibitsManager(item).getType(),
                    attrs: {
                      "data-type": _vm.formExhibitsManager(item).getType()
                    },
                    on: {
                      click: function($event) {
                        return _vm.clickAddCompenent(item)
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [
                        "iconfont",
                        _vm.formExhibitsManager(item).getIcon()
                      ]
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formExhibitsManager(item).getName()))
                    ])
                  ]
                )
              }),
              0
            )
          ],
          1
        )
      ],
      _vm._v(" "),
      _vm.expandFunction === "group" ? _c("group-item-config") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a668b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a668b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config/FormItemConfig.vue
// module id = null
// module chunks = 